<template>
    <BaseModal
        center
        :is-open="modalStore.modals.costSet"
        @close="closeModal">
        <button
            style="
                cursor:
                    url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                    pointer;
            "
            @click="closeModal"
            class="absolute inset-0 z-10 size-full outline-none" />
        <div
            @click.stop
            class="flex h-full min-h-full w-full items-center justify-center rounded-20 bg-gradient-to-tr from-accent to-white/20 max-md:my-5">
            <div
                @click.stop
                class="relative z-20 flex h-full max-h-[calc(100dvh-40px)] w-full overflow-hidden overflow-y-auto rounded-20 px-3 pb-3 pt-10 shadow-2xl md:p-5 md:pt-10">
                <button
                    tabindex="0"
                    class="sr-only pointer-events-none absolute opacity-0"></button>

                <CalculatorSection
                    v-if="calculator && directionSlug"
                    :hide-free-delivery
                    :direction-slug="directionSlug"
                    font-size-lg-title="medium"
                    :calculator="calculator"
                    class="w-full" />
            </div>

            <button
                class="absolute right-5 top-5 z-10 size-8"
                @click="closeModal">
                <AtomIcon
                    name="close"
                    class="size-8 text-accent-100" />
            </button>
        </div>
    </BaseModal>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type {
    ICalculatorSetting,
    TCalculatorType,
} from '~/types/calculator.types.ts'

import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import BaseModal from '~/components/base/base-modal/BaseModal.vue'
import CalculatorSection from '~/components/particles/calculator-section/CalculatorSection.vue'

defineProps({
    directionSlug: {
        type: [String, null] as PropType<TCalculatorType | null>,
        required: true,
    },
    calculator: {
        type: [Object, null] as PropType<ICalculatorSetting | null>,
        required: true,
    },
    hideFreeDelivery: {
        type: Boolean,
        default: false,
    },
})

const modalStore = useModalStore()

function closeModal() {
    modalStore.close('costSet')
}
</script>
